import { TextRegular } from 'UiKit/typography';
import { getMenuPermissions } from 'Helper/getMenuPermissions';

import ActionButton from 'View/studio/component/action-button';

import styles from './styles.module.css';

const getTableList = () => {
  const accessPermission = getMenuPermissions('master-data', 'studio');

  const tableList = [
    {
      name: 'Ruangan',
      key: 'room',
      width: 210,
      sortKey: 'room',
      component: ({ value }) => <TextRegular className={`${styles['column__text']} ${styles['column__text--truncate']}`}>{value}</TextRegular>,
    },
    {
      name: 'Studio',
      key: 'name',
      width: 210,
      sortKey: 'name',
      component: ({ value }) => <TextRegular className={`${styles['column__text']} ${styles['column__text--truncate']}`}>{value}</TextRegular>,
    },
    {
      name: 'Alamat',
      key: 'address',
      width: 210,
      component: ({ value }) => <TextRegular className={`${styles['column__text']} ${styles['column__text--truncate']}`}>{value}</TextRegular>,
    },
    {
      name: 'Area',
      key: 'area',
      width: 150,
      sortKey: 'area.name',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: 'Tipe Aplikasi',
      key: 'appType',
      width: 140,
      sortKey: 'appType.name',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: 'Latitude',
      key: 'latitude',
      width: 130,
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: 'Longitude',
      key: 'longitude',
      width: 130,
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
  ];

  if (accessPermission?.isCanEdit || accessPermission?.isCanDelete) {
    tableList.push({
      name: 'Action',
      key: 'id',
      width: 194,
      position: 'center',
      rightSticky: 0,
      component: ({ values }) => <ActionButton values={values} />,
    });
  }

  return tableList;
};

export default getTableList;
